// src/auth/SignIn.tsx — sign-in screen. Firebase (Google) in deployed envs;
// a dev email form when VITE_DEV_FAKE_AUTH=1.
import { useState } from "react";
import { useAuth } from "./AuthProvider";
import { DEV_FAKE_AUTH } from "@/lib/env";
import { Button, Card, ErrorBanner, Spinner } from "@/components/ui";

export function SignIn() {
  const { status, error, signIn, devSignIn } = useAuth();
  const [email, setEmail] = useState("");
  const authenticating = status === "authenticating";

  return (
    <main className="flex min-h-full items-center justify-center p-6">
      <Card className="w-full max-w-sm">
        <div className="mb-6 text-center">
          <h1 className="font-mono text-3xl font-bold tracking-tight text-ls-fg">PULSE</h1>
          <p className="mt-1 text-sm text-ls-muted">
            Personalized Unified Life Strategy &amp; Expertise
          </p>
        </div>

        {error ? (
          <div className="mb-4">
            <ErrorBanner message={error} />
          </div>
        ) : null}

        {authenticating ? (
          <div className="flex justify-center py-2">
            <Spinner label="Signing in…" />
          </div>
        ) : DEV_FAKE_AUTH ? (
          <form
            className="flex flex-col gap-3"
            onSubmit={(e) => {
              e.preventDefault();
              if (email.trim()) void devSignIn(email.trim());
            }}
          >
            <label className="text-xs text-ls-muted" htmlFor="dev-email">
              Dev sign-in (email)
            </label>
            <input
              id="dev-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              className="rounded-lg border border-white/15 bg-transparent px-3 py-2 text-sm text-ls-fg outline-none focus:border-ls-accent"
            />
            <Button type="submit" disabled={!email.trim()}>
              Continue
            </Button>
          </form>
        ) : (
          <Button onClick={() => void signIn()}>Sign in with Google</Button>
        )}
      </Card>
    </main>
  );
}
